module.exports = __webpack_public_path__ + "fonts/UniSansThin.346ec71e.ttf";